const pillTokens = ({ colors, colorsGrey }) => ({
  colors: {
    default: {
      positive: {
        bg: colors.positive.default,
        color: colors.white,
      },
      informative: {
        bg: colors.informative.default,
        color: colors.white,
      },
      warning: {
        bg: colors.warning.default,
        color: colors.white,
      },
      negative: {
        bg: colors.negative.default,
        color: colors.white,
      },
      brand: {
        bg: colors.brandPrimary[3],
        color: colors.white,
      },
      promotional: {
        bg: colors.promotional.secondary.default,
        color: colors.promotional.primary.default,
      },
    },
    soft: {
      positive: {
        bg: colors.positive.light,
        color: colors.positive.default,
      },
      informative: {
        bg: colors.informative.light,
        color: colors.informative.default,
      },
      warning: {
        bg: colors.warning.light,
        color: colors.warning.default,
      },
      negative: {
        bg: colors.negative.light,
        color: colors.negative.default,
      },
      neutral: {
        bg: colorsGrey.light,
        color: colorsGrey.default,
      },
      brand: {
        bg: colors.brandPrimary[0],
        color: colors.brandPrimary[3],
      },
      promotional: {
        bg: colors.promotional.secondary.default,
        color: colors.promotional.primary.default,
      },
    },
    ghost: {
      positive: {
        bg: colors.positive.default,
        color: colors.positive.default,
      },
      informative: {
        bg: colors.informative.default,
        color: colors.informative.default,
      },
      warning: {
        bg: colors.warning.default,
        color: colors.warning.default,
      },
      negative: {
        bg: colors.negative.default,
        color: colors.negative.default,
      },
      brand: {
        bg: colors.brandPrimary[3],
        color: colors.brandPrimary[3],
      },
      promotional: {
        bg: colors.promotional.secondary.default,
        color: colors.promotional.primary.default,
      },
    },
  },
});

export default pillTokens;
